import { IPOOrderStatusObj } from './ipo.interface';
export enum IPOOrderType {
    NEW = 'n',
    MODIFY = 'm',
    CANCEL = 'd',
    PENDING = 'p',
    REJECTED = 'r',
    FAILED = 'f',
}

export enum IPOOrderCategory {
    individual = 'ind'
}

export enum IPOOrderCategoryDisplay {
    IND = 'Individual Investor'
}

export enum IPOCardFlagTypes {
    IPO_CLOSE = 'IPO closes today!'
}

export let IPOOrderStatus: IPOOrderStatusObj;
(function (reverseInst) {
    reverseInst[reverseInst['S'] = 'Submitted'] = 'S';
    reverseInst[reverseInst['P'] = 'Submitted*'] = 'P';
    reverseInst[reverseInst['R'] = 'Rejected'] = 'R';
    reverseInst[reverseInst['C'] = 'Canceled'] = 'C';
    reverseInst[reverseInst['F'] = 'Failed'] = 'F';
    reverseInst[reverseInst['f'] = 'Rejected'] = 'f';
    reverseInst[reverseInst['r'] = 'Rejected'] = 'r';
    reverseInst[reverseInst['d'] = 'Cancelled'] = 'd';
    reverseInst[reverseInst['p'] = 'Submitted*'] = 'p';
    reverseInst[reverseInst['n'] = 'Submitted*'] = 'n';
    reverseInst[reverseInst['m'] = 'Submitted*'] = 'm';
    reverseInst[reverseInst['s'] = 'Success'] = 's';

})(IPOOrderStatus || (IPOOrderStatus = <IPOOrderStatusObj>{}));

export enum IPOListType {
    ONGOING = 'Ongoing',
    UPCOMING = 'Upcoming',
    RECENTLY_CLOSED = 'Closed',
    RECENTLY_LISTED = 'Listed',
    PREAPPLY = 'Pre-Apply'
}

export enum IPOStatus {
    Failed = 'f',
    Rejected = 'r',
    Deleted = 'd',
}

export enum BidHistoryType {
    ACTIVE = 'active_orders',
    HISTORIC = 'historical_orders',
    PREORDER = 'pre_order_bids',
    HISTORIC_PREORDER = 'historical_pre_orders'
}


export const InvestorTypeMap = {
    'IND': 'Individual Investor'
};

export enum CustomTimeDate {
    ipo_utility_time = 'YYYY-MM-dd hh a'
}

export enum InvestorTypeEnum {
    individualInvestor = 'Individual Investor',
    employee = 'Employee',
    shareholders = 'Shareholders',
    policyholders = 'Policyholders',
    default = 'Default'
}

export enum DiscountType {
    NO_DISCOUNT_ALLOWED = 1,
    IN_VALUE = 2,
    IN_PERCENTAGE = 3,
}

export const IPOCancelTypes: string[] = [IPOOrderType.CANCEL, IPOOrderType.REJECTED, IPOOrderType.FAILED];

export const IPOStarredStatus = ['P', 'p', 'n', 'm'];